import { render, staticRenderFns } from "./LeftMenu.vue?vue&type=template&id=9d6a188c&scoped=true"
import script from "./LeftMenu.vue?vue&type=script&lang=ts"
export * from "./LeftMenu.vue?vue&type=script&lang=ts"
import style0 from "./LeftMenu.vue?vue&type=style&index=0&id=9d6a188c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d6a188c",
  null
  
)

export default component.exports